import { useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaGem } from "react-icons/fa";
import ReactTooltip from "react-tooltip";
import * as theme from "../theme";
import { getBrokerInformation } from "../store/broker";
import translations from "../utils/translations";
import { getInsurersList } from "../store/insurers";

import { getProspectDoc } from "../store/qf";

export const showImportantIcon = ({ importance, type }) => {
  let noImportantIconQTypes = ["message"];
  if (
    (importance === 4 || importance === 5) &&
    !noImportantIconQTypes.includes(type)
  )
    return true;
  return false;
};
const QuestionText = ({ leftString, node }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%", height: "100%" }}>{leftString}</div>
      <div
        style={{
          width: "8%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ImportanceIconShowDecider node={node}></ImportanceIconShowDecider>
      </div>
    </div>
  );
};

export const ImportanceIconShowDecider = ({ node }) => {
  if (showImportantIcon({ importance: node.importance, type: node.type }))
    return <ImportanceIcon node={node}></ImportanceIcon>;
  return null;
};

export const ImportanceIcon = ({ node }) => {
  const [hover, setHover] = useState(false);

  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const ProspectDetails = useSelector(getProspectDoc);
  const [hoverText,setHoverText] = useState(translations[languagepreference].importanceIconTooltipGeneral)
  // let hoverText = `This question is generally essential in the market.`;
  const insurerList = useSelector(getInsurersList);
  // if (node.interestedinsurercodes?.length) {
  //   const insNames = insurerList
  //     .filter(
  //       (x) =>
  //         node.interestedinsurercodes.includes(x.code) &&
  //         x.verticalids?.includes(
  //           ProspectDetails?.answers?.calculatedverticalid
  //         )
  //     )
  //     .map((x) => x.name);
  //   if (insNames.length) {
  //     hoverText = `This question is essential for: ${insNames.join(", ")}`;
  //   }
  //   // console.log(node)
  // }

  useEffect(()=>{
    setHoverText(translations[languagepreference].importanceIconTooltipGeneral)

    if (node.interestedinsurercodes?.length) {
      const insNames = insurerList
        .filter(
          (x) =>
            node.interestedinsurercodes.includes(x.code) &&
            x.verticalids?.includes(
              ProspectDetails?.answers?.calculatedverticalid
            )
        )
        .map((x) => x.name);
      if (insNames.length) {
       const tempHoverText = translations[languagepreference].importanceIconTooltipFor.replace(
        "{insurerNames}",
        insNames.join(", ")
      );
      setHoverText(tempHoverText)
        
      }
      // console.log(node)
    }else{
      setHoverText(translations[languagepreference].importanceIconTooltipGeneral)
    }
  },[languagepreference])

  return (
    <>
      <FaGem
        style={{
          color: hover
            ? theme.COLORS.primary_navyblue
            : theme.COLORS.secondary_orange,
        }}
        size={"1vmin"}
        data-tip
        data-for={`${node.id}`}
        onMouseOver={() => {
          setHover(true);
        }}
        onMouseOut={() => {
          setHover(false);
        }}
        tabIndex="-1"
      ></FaGem>
      <ReactTooltip
        id={node.id}
        effect="solid"
        delayHide={100}
        delayShow={100}
        delayUpdate={500}
        place={"top"}
        type={"light"}
        clickable={true}
      >
        <div
          style={{
            //   backgroundColor: theme.COLORS.secondary_orange,
            //   color: "white",
            maxWidth: "18em",
          }}
        >
          {hoverText}
        </div>
      </ReactTooltip>
    </>
  );
};

export default QuestionText;
